import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSearch, faAngleRight, faAngleDown, faTimes, faCheck} from "@fortawesome/free-solid-svg-icons"
import slugify from 'react-slugify';
import { useDispatch,useSelector } from 'react-redux';
import MediaLibrary from './MediaLibrary';
// import { createBrowserHistory } from "history";
import { useNavigate } from 'react-router-dom';
import { useState,useEffect } from 'react';
import { addCategory, updateCategory } from '../util/api';
import { useParams } from "react-router";
import { updateNotificationSuccess } from '../redux/notificationRedux';

export default function UpdateCategory() {
  // const history = createBrowserHistory({ forceRefresh: true });
  const [inputs, setInputs] = useState({});
  const [slug, setSlug] = useState("");
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [modal, setModal] = useState(false)
  const [imgurl, setimgUrl] = useState(null);
  const navigate = useNavigate()
  const { id } = useParams();
  const [SingleCategory, setSingleCategory] = useState({})
  const categories = useSelector((state) => state.category.categories);
  const [checked, setchecked] = useState(null)
  const [isIconCategory, setisIconCategory] = useState(null)
  let notification = useSelector((state)=> state.notification.notification)

  const handleChange = (e) => {
    setSingleCategory((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
    setSlug(slugify(SingleCategory.nameinEnglish))
  };

  const handleChecked = (e) => {
    setchecked(!checked)
  }

  const uploadImg = (childData) =>{
    setModal(!modal)
    setimgUrl(childData)
  }

  const getSingleCategory = async () => {
    try {
      const res = categories.find(e => e._id === id);
      setSingleCategory(res);
      setchecked(res.showInFrontPage)
      setisIconCategory(res.isIconCategory)
      setimgUrl(res.img)
    } catch {
      console.log("error");
    }
  };

  useEffect(() => {
    getSingleCategory();
  }, [id])


  const handleSubmit = (e) =>{
    e.preventDefault()
    setLoader(true);
    setTimeout(() => {
        setLoader(false);
    }, 3000);
    let category = { ...SingleCategory};
    if (imgurl) {
        category = { ...SingleCategory, img: imgurl, showInFrontPage:checked === null? SingleCategory.showInFrontPage : checked === true? true : checked === false? false : false};
        updateCategory(id, category, dispatch)
        .then((res) => {
          if (res === undefined) {
            dispatch(updateNotificationSuccess({sms:"Category Update Failed",status:false}))
            setTimeout(() => {
              dispatch(updateNotificationSuccess({sms:"",status:null}))
            }, 2000);
          } else {
            dispatch(updateNotificationSuccess({sms:"Category Update Success",status:true}))
            setTimeout(() => {
              dispatch(updateNotificationSuccess({sms:"",status:null}))
            }, 2000);
            navigate(`/edit-category/${SingleCategory._id}`)
          }
      
        });
        
    } else {
        category = { ...SingleCategory, img: imgurl, showInFrontPage:checked === null? SingleCategory.showInFrontPage : checked === true? true : checked === false? false : false};
        updateCategory(id ,category, dispatch)
        .then((res) => {
          if (res === undefined) {
            dispatch(updateNotificationSuccess({sms:"Category Update Failed",status:false}))
            setTimeout(() => {
              dispatch(updateNotificationSuccess({sms:"",status:null}))
            }, 2000);
          } else {
            dispatch(updateNotificationSuccess({sms:"Category Update Success",status:true}))
            setTimeout(() => {
              dispatch(updateNotificationSuccess({sms:"",status:null}))
            }, 2000);
            navigate(`/edit-category/${SingleCategory._id}`)
          }
        });
    }
  }

  const handleRemoveImg = (e) =>{
    e.preventDefault()
    setimgUrl(null);
  }
  
  return (
    <>
    {notification.status === true?
        <div className='notification-bar success'>
          <FontAwesomeIcon icon={faCheck} />
          <p>{notification.sms}</p>
        </div>
        : notification.status === false?
        <div className='notification-bar failed'>
          <FontAwesomeIcon icon={faTimes} />
          <p>{notification.sms}</p>
        </div>
        :
        ""
      }
    {modal? <div className="floating-media">
      <button className="close-modal" onClick={()=>setModal(!modal)}><FontAwesomeIcon icon={faTimes}/></button>
      <MediaLibrary className="author" uploadImg={uploadImg}/>
    </div> : ""}
    <div className="content-area-inner">
      <div className="container-fluid">
        <div className="pagination">
          <Link to="/">Dashboard</Link>
          <FontAwesomeIcon icon={faAngleRight} />
          <Link to="/">Update Category</Link>
        </div>
        <div className="heading">
          <h1>Update Category</h1>
        </div>
        <form className="theme-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-8">
              <div className="theme-card">
                <div className="theme-card-body">
                    <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Category Name (বাংলায় লিখুন)</label>
                            <input type="text" tabIndex="1" name="nameinBangla" value={SingleCategory.nameinBangla} className="form-control" placeholder="Input Here" onChange={handleChange} required/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Category Name (Write in English)</label>
                            <input type="text" tabIndex="2" name="nameinEnglish" value={SingleCategory.nameinEnglish} className="form-control" placeholder="Input Here" onChange={handleChange} required/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Type</label>
                            <select name="categoryType" tabIndex="4" className="form-control" onChange={handleChange} required>
                              {SingleCategory.categoryType? (
                                <option value={SingleCategory.categoryType}>{SingleCategory.categoryType}</option>
                              ):(
                                <option value="">Select Category Type</option>
                              )}
                              <option value="book">Book</option>
                              <option value="post">Post</option>
                              <option value="graphics">Graphics</option>
                            </select>
                            <span style={{background:"#D9D9D9",border:"1px solid #D9D9D9"}}><FontAwesomeIcon icon={faAngleDown} /></span>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Slug /Unque URL</label>
                            <input name="slug" tabIndex="3" type="text" className="form-control" placeholder="www.bookmark.com.bd/" value={slug? slug : SingleCategory.slug} onFocus={handleChange} required/>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Template</label>
                            <select name="template" tabIndex="5" className="form-control" onChange={handleChange} required>
                              {SingleCategory.template? (
                                <option value={SingleCategory.template}>{SingleCategory.template}</option>
                              ):(
                                <option value="">Select Template</option>
                              )}
                              <option value="islamic">Islamic</option>
                            </select>
                            <span style={{background:"#D9D9D9",border:"1px solid #D9D9D9"}}><FontAwesomeIcon icon={faAngleDown} /></span>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Select Status</label>
                            <select name="status" tabIndex="6" type="number" className="form-control" onChange={handleChange} required>
                              {SingleCategory.status === 0 ? (
                                <option value="0">Active</option>
                              ) : (
                                <option value="1">Inactive</option>
                              )}
                              <option value="">Select Status</option>
                              <option value="0">Active</option>
                              <option value="1">Inactive</option>
                            </select>
                            <span style={{background:"#D9D9D9",border:"1px solid #D9D9D9"}}><FontAwesomeIcon icon={faAngleDown} /></span>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Description</label>
                            <textarea name="description" tabIndex="7" value={SingleCategory.description} className="form-control" style={{height:"135px"}} placeholder="Input Here" onChange={handleChange}></textarea>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Position</label>
                            <input type="number" tabIndex="8" name="position" value={SingleCategory.position} min="0" className="form-control" placeholder="Input Here" onChange={handleChange}/>
                          </div>
                          <div className="form-group">
                            <input type="checkbox" tabIndex="9" name="showInFrontPage" onChange={handleChecked} style={{marginRight:"10px"}} value={checked} checked={checked}/>
                            <label>Want to show in homepage?</label>
                          </div>
                          <div className='input-group d-flex align-items-center mb-3' style={{marginTop:"-14px"}}>
                            <label style={{marginLeft:"5px",marginBottom:"0"}}>Is this an <b>Icon</b> category?</label>
                            <input id='yes' type="radio" name='isIconCategory' value="true" style={{marginLeft:"5px",marginBottom:"0"}} checked={SingleCategory.isIconCategory === "true"? true : false} onChange={handleChange}/>
                            <label htmlFor='yes' style={{marginLeft:"5px",marginBottom:"0"}}>Yes</label>
                            <input id='no' type="radio" name='isIconCategory' value="false" style={{marginLeft:"5px",marginBottom:"0"}} checked={SingleCategory.isIconCategory === "false"? true : false} onChange={handleChange}/>
                            <label htmlFor='no' style={{marginLeft:"5px",marginBottom:"0"}}>No</label>
                          </div>
                        </div>
                        {SingleCategory.isIconCategory === "true"?(
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>Enter SVG Icon code</label>
                              <textarea name="svgIcon" className="form-control" style={{height:"135px"}} placeholder="SVG Code" onChange={handleChange}>{SingleCategory.svgIcon}</textarea>
                            </div>
                          </div>
                        ):(
                          ""
                        )}
                    <div>
                </div>
              </div>
            </div>
              </div>
              <div className="group-btn">
                  <button className="btn theme-btn">Submit</button>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="theme-card">
                <div className="theme-card-body">
                  <button className="btn close" onClick={handleRemoveImg}><FontAwesomeIcon icon={faTimes} /></button>
                  {imgurl? <img src={`${process.env.REACT_APP_BASE_URL}/api/alluploads/${imgurl}`} className="w-100" onClick={uploadImg} /> : <div className="form-group upload-img" onClick={uploadImg}>
                      <label>
                      <svg width="72" height="57" viewBox="0 0 72 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M68.0057 10.3334V7.00004H60.8858V10.3334H56.3326L52.7727 0.333374H19.1595L15.5995 10.3334H0.366455V57H71.5657V10.3334H68.0057ZM64.4458 50.3334H7.48638V17H20.733L24.293 7.00004H47.6392L51.1992 17H64.4458V50.3334Z" fill="#E1E1E1"/>
                      <path d="M35.9661 17C32.7977 17 29.7004 17.8797 27.066 19.528C24.4315 21.1762 22.3782 23.5189 21.1657 26.2597C19.9532 29.0006 19.636 32.0166 20.2541 34.9264C20.8722 37.8361 22.398 40.5088 24.6384 42.6066C26.8788 44.7044 29.7333 46.133 32.8408 46.7118C35.9484 47.2906 39.1694 46.9935 42.0966 45.8582C45.0239 44.7229 47.5258 42.8003 49.2861 40.3336C51.0464 37.8668 51.986 34.9667 51.986 32C51.9812 28.0231 50.2919 24.2104 47.2887 21.3983C44.2854 18.5862 40.2134 17.0044 35.9661 17ZM35.9661 40.3333C34.2059 40.3333 32.4852 39.8446 31.0216 38.9289C29.558 38.0132 28.4173 36.7117 27.7437 35.189C27.0701 33.6663 26.8938 31.9908 27.2372 30.3742C27.5806 28.7577 28.4283 27.2729 29.6729 26.1074C30.9176 24.942 32.5034 24.1483 34.2298 23.8268C35.9563 23.5052 37.7457 23.6703 39.372 24.301C40.9982 24.9317 42.3882 25.9998 43.3661 27.3702C44.3441 28.7407 44.866 30.3518 44.866 32C44.866 34.2101 43.9284 36.3298 42.2593 37.8926C40.5903 39.4554 38.3265 40.3333 35.9661 40.3333Z" fill="#E1E1E1"/>
                      </svg>
                      Click here to upload Images
                      </label>
                      <div className="preview-img">
                      <img className="w-100"/>
                      </div>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    </>
  )
}
